import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-at";

/**
 * Wraps React.lazy so that a failed dynamic import (usually a stale chunk
 * hash left in the browser after a new deploy) triggers a one-time hard
 * reload instead of a blank screen.
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (error) {
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      // Only reload once per 10s window to avoid infinite reload loops.
      if (Date.now() - last > 10_000) {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        window.location.reload();
        // Never resolves; the page is reloading.
        return await new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
